<section>
    <div class="mainContent">
        <div class="leftContent">
            <div class="based">
                <img class="imageStripe" src="./assets/img/aboutme/yellow.png">
                <div class="textIcon">
                    <img class="iconLeft" src="assets/img/aboutme/locationIcons.png">
                    <p>{{ 'about-me.based' | translate }}</p>
                </div>
            </div>
            <div class="locate">
                <img class="imageStripe" src="./assets/img/aboutme/blue.png">
                <div class="textIcon">
                    <img class="iconLeft" src="assets/img/aboutme/relocateIcons.png">
                    <p>{{ 'about-me.locate' | translate }}</p>
                </div>
            </div>

            <div class="remote">
                <img class="imageStripe" src="./assets/img/aboutme/orange.png">
                <div class="textIcon">
                    <img class="iconLeft" src="assets/img/aboutme/homeIcons.png">
                    <p>{{ 'about-me.remote' | translate }}</p>
                </div>
            </div>
        </div>
        <div class="rightContent">
            <div class="rightContentTop">
                <div class="whois"><p>{{ 'about-me.title' | translate }}</p></div>
                    <div class="aboutMe"><p>{{ 'about-me.subline' | translate }}</p></div>
                    <div class="lineBlue"><img src="assets/img/aboutme/19_Line.png"></div>
                </div>
            <div class="rightContentMiddle">
                <p>{{ 'about-me.text' | translate: {text} }}</p>
            </div>
            <div class="rightContentBottom">
                <div class="rowBottomBottom"><button class="letsTalk" onclick="window.location.href='mailto:info@michaelspari.de'">{{ 'about-me.button' | translate }}</button></div>
            </div>
        </div>
    </div>
</section>
